import QuickAddToCart from '../cart/quick-add-to-cart';
import { OrderTemplate } from '../../model/order-template';
import PageHelper from '../../helpers/page-helper';
import ProductData from '../../model/product-data';
import PriceData from '../../model/price-data';

export default class QuickAddToOrderTemplate extends QuickAddToCart {

  constructor(form: JQuery, private orderTemplate: OrderTemplate, private refreshCallback: () => void) {
    super(form);
    this.bindAddProductOnSubmit();
  }

  static initAll(forms: JQuery, orderTemplate: OrderTemplate, refreshCallback: () => void): void {
    forms.map((i, formEl) => new QuickAddToOrderTemplate($(formEl), orderTemplate, refreshCallback));
  }

  private bindAddProductOnSubmit() {
    this.form.on('submit', (e) => {
      e.preventDefault();

      if (!this.productCode.val()) {
        return;
      }

      PageHelper.showLoadingIndicator();
      this.submit.prop('disabled', true);

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      OrderTemplate.getProduct(this.productCode.val() as string)
        .done((data: ProductData) => {

          const price = (data.price as PriceData).value.toFixed(2);
          const missingProductUrl = '/_ui/responsive/common/images/missing-product.png';
          let customerStock = 0;
          data.warehouses?.forEach((warehouse) => {
            if (warehouse.type === 'CUSTOMER') {
              customerStock = warehouse.stockLevelAmount;
            }
          });

          this.orderTemplate.addProduct(
            {
              productCode: data.code,
              quantity: data.roundingQuantity as number,
              roundingQuantity: data.roundingQuantity as number,
              name: data.name,
              price,
              sapNetPrice: data.sapPrice?.value.toString() || '',
              imageUrl: data.images?.length > 0 ? data.images[0].url : missingProductUrl,
              partNumber: data.partNumber,
              customerStock,
              productUrl: data.url,
              showAddToCartButton: !(data.sapBlocked) || data.hasSubstitution,
            },
          );
          this.refreshCallback();

          window.NotificationHelper.clearNotifications();
          this.productCode.val('');

        })
        .fail((err) => {
          window.NotificationHelper.clearNotifications();
          window.NotificationHelper.showError(JSON.parse(err.responseText));
        })
        .always(() => {
          PageHelper.clearLoadingIndicator();
          this.submit.prop('disabled', false);
          this.formSubmitted = false;
        });
    });
  }
}
